export default [
    {
        title: 'وظایف',
        icon: 'TrelloIcon',
        children: [
            {
                title: 'پروژه ها',
                icon: '',
                route: 'Projects_List',
                permission: 'projects.index',
            },
            {
                title: 'لیست وظایف',
                icon: '',
                route: {path:'/tasks/inbox'},
                permission: 'todo',
            }
        ]
    }
]
